import React, { Component } from 'react';
import Button from 'material-ui/Button';
import Gravatar from 'react-gravatar';
import Auth from '../../../helpers/auth';

import './menu.css';

class Menu extends Component {

    signout() {
        const context = window.parent || window;
        context.location = process.env.REACT_APP_ACCOUNTS_API + '/logout?continue='+window.location.href;
    }

    goToMyAccount(user) {
        const context = window.parent || window;
        context.location = process.env.REACT_APP_ACCOUNTS_APP + '/#/' + user.id;
    }

    render() {
        const user = Auth.getUserData() || {};

        return (
            <div className="account-popmenu">
                <div className="profile">
                    <Gravatar email={user.email || 'unknow@polibrasnet.com.br'} size={65} default="mm" className="avatar" /><br />
                    <h3>{user.display_name || user.name || 'Sem nome'}</h3>
                    <small>{user.email || '-'}</small><br />
                    <small>({user.company_id})</small>
                </div>

                <div className="actions">
                    <Button onClick={this.goToMyAccount.bind(this, user)}>Minha Conta</Button>
                    <Button onClick={this.signout.bind(this)}>Sair</Button>
                </div>
            </div>
        );
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/psuite-js/components/mui/AccountPopMenu/Menu.js